import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "el-text__primary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" See All ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  href: ""
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" - ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_popover, {
        visible: _ctx.isPopoverVisible,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isPopoverVisible) = $event)),
        width: 800,
        trigger: "manual"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_input, {
            placeholder: "Search ...",
            modelValue: _ctx.searchValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
            onBlur: _ctx.handleBlur,
            onInput: _ctx.search
          }, null, 8, ["modelValue", "onBlur", "onInput"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_space, {
            direction: "vertical",
            style: {"display":"flex"},
            fill: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_scrollbar, {
                "max-height": "400px",
                width: "100%"
              }, {
                default: _withCtx(() => [
                  (_ctx.searchResults.groups && _ctx.searchResults.groups.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.searchResults.groups, (group, index) => {
                        return (_openBlock(), _createBlock(_component_el_row, {
                          key: index,
                          gutter: 20
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 4,
                              lg: 4,
                              xl: 4,
                              class: "el-background__light-grey"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("strong", _hoisted_1, _toDisplayString(group.groupName.toString().trim()), 1),
                                _hoisted_2,
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: ($event: any) => (_ctx.viewGroup(group.groupName, group.results.dataset_name))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createElementVNode("small", null, _toDisplayString(group.results.totals), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 20,
                              lg: 20,
                              xl: 20
                            }, {
                              default: _withCtx(() => [
                                (
                      group.results && group.results.rows && group.results.rows.length > 0
                    )
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(group.results.rows, (row, rowIndex) => {
                                      return (_openBlock(), _createElementBlock("div", { key: rowIndex }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(row), ([key, value], rowItemIndex) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: rowItemIndex,
                                            onClick: ($event: any) => (_ctx.viewSingle(group.groupName, row, group.results.dataset_name))
                                          }, [
                                            (key !== 'invoice_id')
                                              ? (_openBlock(), _createElementBlock("a", _hoisted_5, [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.getColumnHeaderText(key)), 1),
                                                  _hoisted_6,
                                                  _createElementVNode("span", null, _toDisplayString(value), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_4))
                                        }), 128)),
                                        _createVNode(_component_el_divider)
                                      ]))
                                    }), 128))
                                  : (_ctx.searchValue !== '')
                                    ? (_openBlock(), _createBlock(_component_el_empty, {
                                        key: 1,
                                        description: "No Results Found"
                                      }))
                                    : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_divider)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_empty, {
                        key: 1,
                        description: "No Results Found"
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}